import { JSX } from "react";

import { Box } from "@mui/material";
import { isMobile } from "react-device-detect";

import LangBox from "./LangBox";
import Profile from "./Profile/Profile";

const styles = {
  navRightContainer: { display: "flex", alignItems: "center", gap: 1 },
};

function TopNavRightBox(): JSX.Element | null {
  if (isMobile) return null;

  return (
    <Box sx={styles.navRightContainer}>
      <LangBox />
      <Profile />
    </Box>
  );
}

export default TopNavRightBox;
